let bindedActions;

export const setBindedActions = (_actions) => {
  bindedActions = _actions;
};

export const getBindedActions = () => bindedActions;
